import DockingPane from './DockingPane';

export default DockingPane;
